// extracted by mini-css-extract-plugin
module.exports = {"booking-wizard":"x_ch","bookingWizard":"x_ch","block":"x_cj","button":"x_ck"};